import React, { useMemo } from 'react'
import styles from '../dropdown.module.scss'
import Typography from '../../Typography'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Icon } from '../../index'

const LabelWrapper = ({ startIcon = null, endIcon = null, children }) => (
  <span
    className={clsx('label-wrapper', {
      [styles[`label-withStartIcon`]]: !!startIcon && children,
      [styles[`label-withEndIcon`]]: !!endIcon && children,
    })}
  >
    {children}
  </span>
)

LabelWrapper.propTypes = {
  startIcon: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.element,
    PropTypes.elementType,
    PropTypes.oneOf([null]),
  ]),
  endIcon: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.element,
    PropTypes.elementType,
    PropTypes.oneOf([null]),
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
}

const DropdownItem = ({
  startIcon = null,
  endIcon = null,
  children,
  className,
  noHover,
  component = null,
  variant = 'Body-15',
  ...rest
}) => {
  const Start = useMemo(
    () =>
      typeof startIcon === 'string' ? (
        <Icon name={startIcon} size={'m'} color={'Label-GU-Primary'} />
      ) : (
        startIcon
      ),
    [startIcon],
  )

  const End = useMemo(
    () =>
      typeof endIcon === 'string' ? (
        <Icon name={endIcon} size={'m'} />
      ) : (
        endIcon
      ),
    [endIcon],
  )

  return (
    <Typography
      component={component || 'div'}
      variant={variant}
      className={clsx(
        'dropdown-item',
        styles.item,
        {
          [styles['no-hover']]: noHover,
        },
        className,
      )}
      noMargin
      {...rest}
    >
      {Start}
      {startIcon || endIcon ? (
        <LabelWrapper startIcon={startIcon} endIcon={endIcon}>
          {children}
        </LabelWrapper>
      ) : (
        children
      )}
      {End}
    </Typography>
  )
}

DropdownItem.propTypes = {
  startIcon: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.elementType,
  ]),
  endIcon: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.elementType,
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  noHover: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  variant: PropTypes.string,
}

export default DropdownItem
